export function getAuthTokenCookieValue() {
    const cookiePieces = decodeURIComponent(document.cookie)?.split(';') || [];
    const cookie = cookiePieces
        .find((piece) => piece.trim().startsWith('AUTH_TOKEN'))
        ?.trim();
    return cookie?.split('=')?.[1];
}
